export const authRoles = Object.freeze({
  CLIENT: 'client',
  ADMIN: 'admin',
  SUPER_ADMIN: 'superadmin',
});
